/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceLineType } from './BalanceLineType';
import {
    BalanceLineTypeFromJSON,
    BalanceLineTypeFromJSONTyped,
    BalanceLineTypeToJSON,
    BalanceLineTypeToJSONTyped,
} from './BalanceLineType';
import type { AccountCategory } from './AccountCategory';
import {
    AccountCategoryFromJSON,
    AccountCategoryFromJSONTyped,
    AccountCategoryToJSON,
    AccountCategoryToJSONTyped,
} from './AccountCategory';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTransactionCodeResponse
 */
export interface GetTransactionCodeResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTransactionCodeResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionCodeResponse
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionCodeResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionCodeResponse
     */
    appliesToTransactionCode: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionCodeResponse
     */
    isCredit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionCodeResponse
     */
    isDebit: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionCodeResponse
     */
    isDeferrable: boolean;
    /**
     * 
     * @type {AccountCategory}
     * @memberof GetTransactionCodeResponse
     */
    category: AccountCategory | null;
    /**
     * 
     * @type {BalanceLineType}
     * @memberof GetTransactionCodeResponse
     */
    balanceLineType: BalanceLineType | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionCodeResponse
     */
    requiresClass: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionCodeResponse
     */
    requiresAppointment: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTransactionCodeResponse
     */
    sortOrder: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetTransactionCodeResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTransactionCodeResponse
     */
    updatedAt: Date | null;
}



/**
 * Check if a given object implements the GetTransactionCodeResponse interface.
 */
export function instanceOfGetTransactionCodeResponse(value: object): value is GetTransactionCodeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('appliesToTransactionCode' in value) || value['appliesToTransactionCode'] === undefined) return false;
    if (!('isCredit' in value) || value['isCredit'] === undefined) return false;
    if (!('isDebit' in value) || value['isDebit'] === undefined) return false;
    if (!('isDeferrable' in value) || value['isDeferrable'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('balanceLineType' in value) || value['balanceLineType'] === undefined) return false;
    if (!('requiresClass' in value) || value['requiresClass'] === undefined) return false;
    if (!('requiresAppointment' in value) || value['requiresAppointment'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetTransactionCodeResponseFromJSON(json: any): GetTransactionCodeResponse {
    return GetTransactionCodeResponseFromJSONTyped(json, false);
}

export function GetTransactionCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTransactionCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'code': json['code'],
        'name': json['name'],
        'appliesToTransactionCode': json['appliesToTransactionCode'],
        'isCredit': json['isCredit'],
        'isDebit': json['isDebit'],
        'isDeferrable': json['isDeferrable'],
        'category': AccountCategoryFromJSON(json['category']),
        'balanceLineType': BalanceLineTypeFromJSON(json['balanceLineType']),
        'requiresClass': json['requiresClass'],
        'requiresAppointment': json['requiresAppointment'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

export function GetTransactionCodeResponseToJSON(json: any): GetTransactionCodeResponse {
    return GetTransactionCodeResponseToJSONTyped(json, false);
}

export function GetTransactionCodeResponseToJSONTyped(value?: GetTransactionCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'code': value['code'],
        'name': value['name'],
        'appliesToTransactionCode': value['appliesToTransactionCode'],
        'isCredit': value['isCredit'],
        'isDebit': value['isDebit'],
        'isDeferrable': value['isDeferrable'],
        'category': AccountCategoryToJSON(value['category']),
        'balanceLineType': BalanceLineTypeToJSON(value['balanceLineType']),
        'requiresClass': value['requiresClass'],
        'requiresAppointment': value['requiresAppointment'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

